<template>
    <div class="attribute-management">
        <div class="attribute-header mb-4">
            <h4>{{ title }}</h4>
            <b-button @click="addNew" variant="primary" size="sm">
                <b-icon icon="plus" class="mr-1"></b-icon>
                Add New
            </b-button>
        </div>

        <!-- Add/Edit Form -->
        <b-card v-if="showForm" class="mb-4">
            <b-form @submit.prevent="saveItem">
                <slot name="form-fields" :item="currentItem"></slot>
                <div class="form-actions mt-3">
                    <b-button type="submit" variant="success" :disabled="saving">
                        <b-icon icon="check" class="mr-1"></b-icon>
                        {{ currentItem.id ? 'Update' : 'Save' }}
                    </b-button>
                    <b-button @click="cancelEdit" variant="outline-secondary" class="ml-2">
                        Cancel
                    </b-button>
                </div>
            </b-form>
        </b-card>

        <!-- Items Table -->
        <b-card>
            <b-table 
                :items="items" 
                :fields="fields" 
                :busy="loading"
                striped 
                hover
                responsive
                show-empty
            >
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>

                <template #empty>
                    <div class="text-center text-muted py-4">
                        No items found. Click "Add New" to create one.
                    </div>
                </template>

                <template #cell(ts)="data">
                    {{ formatDate(data.value) }}
                </template>

                <template #cell(actions)="row">
                    <b-button @click="editItem(row.item)" size="sm" variant="outline-primary" class="mr-2">
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                    <b-button @click="deleteItem(row.item)" size="sm" variant="outline-danger">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'AttributeManagement',
    props: {
        title: String,
        items: Array,
        fields: Array,
        itemKey: {
            type: String,
            default: 'id'
        },
        fetchMethod: Function,
        saveMethod: Function,
        deleteMethod: Function
    },
    data() {
        return {
            showForm: false,
            currentItem: {},
            loading: false,
            saving: false
        }
    },
    methods: {
        formatDate(timestamp) {
            if (!timestamp) return '';
            return new Date(timestamp).toLocaleString();
        },
        
        addNew() {
            this.currentItem = {};
            this.showForm = true;
        },
        
        editItem(item) {
            this.currentItem = { ...item };
            this.showForm = true;
        },
        
        cancelEdit() {
            this.currentItem = {};
            this.showForm = false;
        },
        
        async saveItem() {
            this.saving = true;
            try {
                await this.saveMethod(this.currentItem);
                this.currentItem = {};
                this.showForm = false;
                this.$emit('saved');
            } catch (error) {
                console.error('Error saving item:', error);
            } finally {
                this.saving = false;
            }
        },
        
        deleteItem(item) {
            if (confirm(`Are you sure you want to delete ${item[this.fields[1].key]}?`)) {
                this.deleteMethod(item);
                this.$emit('saved');
            }
        },
        
        async refresh() {
            this.loading = true;
            try {
                await this.fetchMethod();
            } catch (error) {
                console.error('Error refreshing:', error);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style scoped>
.attribute-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.form-actions {
    display: flex;
    gap: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/AttributeManagement.vue